import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * Visual indicator for swipe-back gesture
 * Shows arrow and progress during swipe from left edge
 */
export default function SwipeBackIndicator({ swipeProgress, isSwipingBack }) {
  if (!isSwipingBack || swipeProgress === 0) {
    return null;
  }

  const opacity = Math.min(swipeProgress * 2, 1);
  const translateX = swipeProgress * 60;

  return (
    <div 
      className="fixed left-0 top-1/2 -translate-y-1/2 z-[200] pointer-events-none"
      style={{
        opacity: opacity,
        transform: `translateX(${translateX}px) translateY(-50%)`,
        transition: 'none',
      }}
    >
      <div className="bg-white dark:bg-gray-800 rounded-full p-3 shadow-lg">
        <ArrowBackIcon 
          className="text-blue-500"
          fontSize="medium"
        />
      </div>
    </div>
  );
}
